<div>
  <app-users-filter
    [roles]="roles"
    [weeeSystems]="weeeSystems"
    (search)="searchUsers($event)">
  </app-users-filter>
  <mat-divider></mat-divider>
  <app-users-table *ngIf="users"
    [roles]="roles"
    [weeeSystems]="weeeSystems"
    [users]="users.content"
    [page]="users.number"
    [pageSize]="users.size"
    [totalElements]="users.totalElements"
    (loadUsers)="loadUsers($event)"
    (updateUserStatus)="updateUserStatus($event)"
    (deleteUser)="deleteUser($event)"
    (printUsers)="printUsers()">
  </app-users-table>
</div>
